var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8507 2.90625C12.8507 3.04297 12.8507 3.15234 12.8507 3.28906C12.8507 7.08984 9.97964 11.4375 4.70229 11.4375C3.06167 11.4375 1.55776 10.9727 0.299951 10.1523C0.518701 10.1797 0.737451 10.207 0.983545 10.207C2.32339 10.207 3.55386 9.74219 4.53823 8.97656C3.28042 8.94922 2.21401 8.12891 1.85854 6.98047C2.04995 7.00781 2.21401 7.03516 2.40542 7.03516C2.65151 7.03516 2.92495 6.98047 3.1437 6.92578C1.8312 6.65234 0.846826 5.50391 0.846826 4.10938V4.08203C1.22964 4.30078 1.69448 4.41016 2.15933 4.4375C1.36636 3.91797 0.87417 3.04297 0.87417 2.05859C0.87417 1.51172 1.01089 1.01953 1.25698 0.609375C2.67886 2.33203 4.81167 3.48047 7.19058 3.61719C7.13589 3.39844 7.10854 3.17969 7.10854 2.96094C7.10854 1.375 8.3937 0.0898438 9.97964 0.0898438C10.8 0.0898438 11.5382 0.417969 12.0851 0.992188C12.714 0.855469 13.3429 0.609375 13.8898 0.28125C13.671 0.964844 13.2335 1.51172 12.632 1.86719C13.2062 1.8125 13.7804 1.64844 14.2726 1.42969C13.8898 2.00391 13.3976 2.49609 12.8507 2.90625Z",
    fill: "#086AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.f1634d350b746e4b25c4b47f444552c3.svg";
export { ForwardRef as ReactComponent };